var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusUnpublished(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon",
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 24a16 16 0 1 1 32 0 16 16 0 0 1-32 0Zm29.3 0a13.3 13.3 0 1 0-26.6 0 13.3 13.3 0 0 0 26.6 0Zm-14-10c-.4 0-.8.4-.8.8V26c0 .5.4.9.9.9H25c.4 0 .8-.4.8-.9V15c0-.5-.4-1-.8-1h-1.7Zm0 16.2c-.4 0-.8.4-.8.8v1.7c0 .5.4.9.9.9H25c.4 0 .8-.4.8-.9V31c0-.4-.4-.8-.8-.8h-1.7Z",
    clipRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusUnpublished);
export default __webpack_public_path__ + "static/media/StatusUnpublished.47e19212bbd9986b3410637dbcd6667a.svg";
export { ForwardRef as ReactComponent };